import axios from "axios";
import swal from "sweetalert";
import { LogoutUser } from "../../constant/Logout";
import { isAccessToken } from "../localStorage";

export const env = process.env.REACT_APP_ENV;
export const dev = process.env.REACT_APP_BASE_URL;
export const feedback = process.env.REACT_APP_FEEDBACK_URL;
export const annualComp = process.env.REACT_APP_ANNUAL_COMPLIANCES;
export const policyAPi = process.env.REACT_APP_POLICY_URL;
export const policyPdfAPi = process.env.REACT_APP_POLICY_PDF_URL;
export const engPdfUrl =process.env.REACT_APP_ENGPDF_URL;
var accessToken = "";
const userDetails = localStorage.getItem("userDetails");
const userDetailsList: any = userDetails;
const userDetailsJson = JSON.parse(userDetailsList);

//console.log(userDetailsJson, "userDetailsJsonuserDetailsJsonuserDetailsJson");
if (userDetailsJson !== null) {
  accessToken = userDetailsJson.accessToken;
}
export const instance = axios.create({
  baseURL: dev,
  timeout: 100000,
  headers: { "X-Custom-Header": "foobar", Authorization: "Bearer " + accessToken },
});
export const instancePolicy = axios.create({
  baseURL: policyAPi,
  timeout: 100000,
  headers: { "X-Custom-Header": "foobar", Authorization: "Basic d29ya1BvcnRhbDpwQHNzd29yZA==" },
});

instance.interceptors.request.use(
  function (config) {
    //console.log("------------request-----------", config);
    return config;
  },
  function (error) {
    // console.log("------------request error-----------", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // console.log("------------response-----------", response);
    if (response.status >= 400 && response.status <= 500) {
      swal(`Something went wrong! ${response.status}`, "", "error");
      return Promise.reject("Something went wrong!");
    }

    if (response?.data?.error) {
      swal(response.data.error, "", "error");
      return Promise.reject(response.data.error);
    }
    return response;
  },
  function (error) {
    //console.log("------------response error-----------", error.response.data.error);
    // if (
    //   error.response.data.error === "JWT Token Expired, Please login again !!!"
    // ) {
    //   localStorage.removeItem("userDetails");
    //   localStorage.removeItem("otp");
    //   localStorage.removeItem("forgetpass");
    //   localStorage.removeItem("isSSO");
    //   localStorage.removeItem("URP");
    //   localStorage.removeItem("store");
    //   sessionStorage.removeItem("isSession");
    //   window.location.href = `${dev}/api/users/user/logout?accessToken=${userDetailsJson.accessToken}`;
     
    // }
    if (
      error.response.status === 401
    ) {    
        // LogoutUser()     
        // swal({
        //   text: "Session timeout. Click here to login again.",
        //   icon: "warning",
        //   dangerMode: true,
        // })
        //   .then(async() => {
            localStorage.removeItem("userDetails");
            localStorage.removeItem("otp");
            localStorage.removeItem("forgetpass");
            localStorage.removeItem("isSSO");
            localStorage.removeItem("URP");
            localStorage.removeItem("store");
            sessionStorage.removeItem("isSession");
            localStorage.removeItem("isAdmin");
            localStorage.removeItem("userPhotoDetails");
            window.location.href="/login"
        //   });
    
    }
    //TODO:
    if (error.message == "Network Error") {
      swal("Please check your network connection", "", "error");
      return Promise.reject(error);
    }
    swal(error, "", "error");
    return Promise.reject(error);
  }
);

//TODO: remove at time of production
const myInterceptor = axios.interceptors.request.use(function () {
  /*...*/
});
axios.interceptors.request.eject(myInterceptor);
